import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import "./chatbox.css";
import Paper from "@mui/material/Paper";
// import { GeneralContext } from "Root/profile/ProfileRoutes";
import { useHistory } from "react-router-dom";
import toastService from "Root/profile/toastService";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
import { apiGetPreviousMessages, apiSendMessageToRD } from "Root/api/apiProfile";
import sendArrow from "Images/profile/send-arrow.png";
import { parseDateTime, convertMilitaryToAmPm } from "../../../../helpers/util";
const Chatbox = ({ dietitianPhoto }) => {
    const history = useHistory();
    // const { setGlobalLoading } = useContext(GeneralContext);
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");
    const messageFlow = useRef(null);
    const userMessageRef = useRef(null);
    const currentDate = new Date();
    const defaultMessage = {
        is_staff: true,
        timestamp: new Date().toString(),
        message: (_jsxs("div", { children: [_jsxs("p", { children: ["Hi\u00A0", user.name, "! Welcome to #TeamGainful!"] }), _jsx("p", { children: "I\u2019m here to help if you have any questions about your blend, diet and exercise goals." }), _jsxs("p", { children: ["I\u2019ll respond shortly here as well as via email at\u00A0", user.email, ", so you\u2019ll never miss a message!"] }), _jsxs("p", { children: ["If there\u2019s a different email you\u2019d like to use, you can change your\u00A0", _jsx("a", { role: "button", style: { textDecoration: "underline", cursor: "pointer" }, onClick: () => history.push("/app/settings#accountDetails"), onKeyUp: () => history.push("/app/settings#accountDetails"), tabIndex: 0, children: "email here." })] })] })),
    };
    const fetchDietitianMessage = async () => {
        const data = await apiGetPreviousMessages();
        if (data) {
            setMessages(data);
        }
    };
    useEffect(() => {
        fetchDietitianMessage();
        window.localStorage.getItem("userMessage") && setNewMessage(window.localStorage.getItem("userMessage"));
    }, []);
    useEffect(() => {
        // scroll to bottom of messages anytime theres a new one
        if (messageFlow.current) {
            messageFlow.current.scrollTop = messageFlow.current.scrollHeight;
        }
        // scroll to user message if there is any
        if (newMessage && userMessageRef.current) {
            userMessageRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [messages, newMessage, userMessageRef]);
    const updateNewMessage = (e) => {
        setNewMessage(e.target.value);
        localStorage.setItem("userMessage", e.target.value);
    };
    const getUserAvatar = user.name && user.name.split("")[0].toUpperCase();
    const getStaffAvatar = _jsx("img", { src: dietitianPhoto, alt: "dietitian", width: 40 });
    const sendMessage = async () => {
        try {
            // setGlobalLoading(true);
            dispatch(setGlobalLoading(true));
            await apiSendMessageToRD({ msg: newMessage });
            setNewMessage("");
            localStorage.removeItem("userMessage");
            fetchDietitianMessage();
            toastService.successMessage("Success: your RD will respond within 1 business day");
        }
        catch (e) {
            toastService.errorMessage("Something went wrong.");
        }
        finally {
            // setGlobalLoading(false);
            dispatch(setGlobalLoading(false));
        }
    };
    const formatDateTimeForMessages = (datetime) => {
        const dateTimeData = parseDateTime(datetime);
        const { day, year, month, date, hour, minutes } = dateTimeData;
        const { formattedHour, amPm } = convertMilitaryToAmPm(hour);
        const formattedYear = year.toString().split("").splice(0, 2).join("");
        const formattedMonth = month.toString().length === 1 ? `0${month}` : month;
        const formattedMinutes = minutes.toString().length === 1 ? `0${minutes}` : minutes;
        return `${formattedMonth}/${date}/${formattedYear} | ${formattedHour}:${formattedMinutes} ${amPm}`;
    };
    return (_jsx("div", { className: "chat-box", children: _jsxs(Paper, { elevation: 3, children: [_jsxs("div", { className: "msg-page", id: "msg-page", ref: messageFlow, children: [_jsx("div", { className: "chat-date", children: formatDateTimeForMessages(currentDate) }), _jsxs("div", { className: "chat-bubble-row", style: { flexDirection: "row" }, children: [_jsx("div", { className: "avatar", style: defaultMessage.is_staff ? { marginRight: "15px" } : { marginLeft: "15px" }, children: defaultMessage.is_staff ? getStaffAvatar : getUserAvatar }), _jsx("div", { className: "chat-bubble-container", children: _jsx("div", { className: `chat-bubble ${defaultMessage.is_staff ? "is-other" : "is-user"}`, children: _jsx("div", { className: "message", style: { color: defaultMessage.is_staff ? "#333333" : "#F2F2F2", fontSize: "16px" }, children: defaultMessage.message }) }) })] }, defaultMessage.timestamp), messages.length
                            ? messages.map((message) => (_jsxs("div", { className: "chat-bubble-row", style: { flexDirection: message.is_staff ? "row" : "row-reverse" }, children: [_jsx("div", { className: "avatar", style: message.is_staff ? { marginRight: "15px" } : { marginLeft: "15px" }, children: message.is_staff ? getStaffAvatar : getUserAvatar }), _jsx("div", { className: "chat-bubble-container", children: _jsx("div", { className: `chat-bubble ${message.is_staff ? "is-other" : "is-user"}`, children: _jsx("div", { className: "message", children: _jsx("p", { style: { color: message.is_staff ? "#333333" : "#F2F2F2" }, children: message.is_staff ? (_jsx("span", { dangerouslySetInnerHTML: { __html: message.message_html } })) : (message.message) }) }) }) })] }, message.message.slice(0, 6))))
                            : null] }), _jsxs(Paper, { className: "message-input-container", elevation: 4, children: [_jsx("input", { ref: userMessageRef, className: "chatbox-input", id: "chatbox-input", type: "text", value: newMessage, onChange: updateNewMessage, placeholder: "Type a message..." }), _jsx("button", { type: "button", className: "chatbox-send-button", onClick: sendMessage, children: _jsx("img", { alt: "send-arrow", src: sendArrow }) })] })] }) }));
};
export default Chatbox;
